module.exports = __webpack_public_path__ + "img/chargeStage_online.30eef96c.png";